import requestApi from "../../api/fetchApi";
import { IncomeInviteSchema } from "./schemas";


class InvitesApi {

    /**
     * Получить список приглашений.
     * */
    static async get_income(): Promise<IncomeInviteSchema[]> {
        return requestApi.GET(`/api/projects-invites/my`);
    }

    /**
     * Принять приглашение.
     * */
    static async accept_invite(inviteId: number): Promise<void> {
        return requestApi.POST(`/api/projects-invites/${inviteId}/accept`);
    }

    /**
     * Отклонить приглашение.
     * */
    static async reject_invite(inviteId: number): Promise<void> {
        return requestApi.POST(`/api/projects-invites/${inviteId}/reject`);
    }
}

export default InvitesApi;
